import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import Modal from '@mui/material/Modal';
import { Close as CloseIcon, ContactPhoneOutlined } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import ViewField from './viewField';
import { formatNumber } from 'src/utils/helperFunctions';
import { formatClientId } from 'src/utils/helperFunctions';
import { getPreviousSales } from 'src/services/salesService';

const ViewSales = ({ open, onClose, viewSales = {} }) => {
  const [previousMonthSale, setPreviousMonthSale]: any = useState({});
  const [sale, setSale]: any = useState({});
  const theme = useTheme();
  const getPreviousSalesData = async ({ year, month, clientId }) => {
    try {
      if (!year || !month || !clientId) return;
      const data = await getPreviousSales({ year, month, clientId });
      if (data && data.meta && data.meta.status === 200) {
        setPreviousMonthSale(data.data);
      }
    } catch (error) {
      setPreviousMonthSale({});
      console.error('Error fetching clients:', error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    let sale: any = viewSales;
    if (sale) {
      sale = {
        ...sale,
        otherDeductions:
          Number(sale.gasolineAmount) +
          Number(sale.carWash) +
          Number(sale.newsPaper) +
          Number(sale.exemptFood) +
          Number(sale.otherExempt),
        totalExempt:
          Number(sale.gasolineAmount) +
          Number(sale.totalExempt) +
          Number(sale.totalLowTax)
      };
    }

    setSale(sale);
    getPreviousSalesData({
      year: sale?.year,
      month: sale?.month,
      clientId: sale?.client && sale.client.id
    });
  }, [viewSales]);
  console.log(
    formatNumber(
      sale?.carWash +
      sale?.newsPaper +
      sale?.exemptFood +
      sale?.saleTaxHoliday +
      sale?.otherExempt +
      sale?.ebt +
      sale?.gasolineAmount
    )
  );
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          // Other styles...
          backdropFilter: 'blur(8px)', // Adjust blur intensity as needed
          WebkitBackdropFilter: 'blur(8px)' // For Safari support
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%', // Adjust this percentage as needed
            height: '85%', // Adjust this percentage as needed
            bgcolor: 'background.paper',
            borderRadius: 4,
            boxShadow: 24,
            p: 4,
            overflowY: 'auto',
            overflowX: 'hidden',
            border: 'none'
            // '&::-webkit-scrollbar': {
            //   display: 'none'
            // },
            // msOverflowStyle: 'none',
            // scrollbarWidth: 'none'
          }}
        >
          <CloseIcon
            sx={{
              position: 'sticky',
              top: -25,
              left: '100%',
              cursor: 'pointer',
              zIndex: 2,
              backgroundColor: 'background.paper',
              color: 'red'
            }}
            onClick={() => handleClose()}
          />

          <Grid container sx={{ mx: 4, py: 2 }}>
            <ViewField
              label={'Client ID'}
              // value1={(sale && sale.client && sale.client.id) || ''}
              value1={
                (sale && sale.client && formatClientId(sale.client.id)) || ''
              }
              value2={undefined}
            />
            <ViewField
              label={'Federal Tax ID'}
              value1={(sale && sale.client && sale.client.federalTaxId) || ''}
              value2={undefined}
            />
            <ViewField
              label={'Legal Business Name'}
              value1={
                (sale && sale.client && sale.client.legalBusinessName) || ''
              }
              value2={undefined}
            />
            <ViewField
              label={'Doing Business AS'}
              value1={
                (sale && sale.client && sale.client.doingBusinessAs) || ''
              }
              value2={undefined}
            />
            <ViewField
              label={'State'}
              value1={(sale && sale.client && sale.client.state) || ''}
              value2={undefined}
            />
            <ViewField
              label={'County'}
              value1={(sale && sale.client && sale.client.county) || ''}
              value2={undefined}
            />
            <ViewField
              label={'City'}
              value1={(sale && sale.client && sale.client.city) || ''}
              value2={undefined}
            />
            <ViewField
              label={'Sales Tax ID'}
              value1={
                (sale &&
                  sale.client &&
                  sale.client.salesTaxes &&
                  sale.client.salesTaxes.salesTaxId) ||
                ''
              }
              value2={undefined}
            />
            <Grid item xs={12}>
              <br></br>
            </Grid>
            <ViewField
              label={'Month / Year'}
              value1={(sale && `${sale.month} - ${sale.year}`) || ''}
              value2={undefined}
            />
            <Grid item xs={12}>
              <br></br>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  <div>
                    <Typography
                      variant="body1"
                      color={'Red'}
                      fontWeight={'bold'}
                    >
                      Permanent Notes
                    </Typography>
                    <Typography variant="body1" color={'Red'}>
                      {sale?.client?.salesTaxes?.importantNotes ?? ''}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" color={'Red'} fontWeight={'bold'}>
                    Temporary Notes
                  </Typography>
                  <Typography variant="body1" color={'Red'}>
                    {sale?.temporaryNotes ?? ''}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <br></br>
            </Grid>
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' && (
                <ViewField
                  label={'Gross Sales'}
                  value1={formatNumber(sale && sale.totalSales) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <Grid item xs={12}>
                  <br></br>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <Grid item xs={12} sm={12}>
                  <Box p={0} mt={1}>
                    <Typography
                      variant="h5"
                      color={'black'}
                      fontWeight={'bold'}
                    >
                      Temporary Exemptions
                    </Typography>
                  </Box>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Sales Tax Holiday'}
                  value1={formatNumber(sale && sale.saleTaxHoliday) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <Grid item xs={12}>
                  <br></br>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <Grid item xs={12} sm={12}>
                  <Box p={0} mt={1}>
                    <Typography
                      variant="h5"
                      color={'black'}
                      fontWeight={'bold'}
                    >
                      Exemptions
                    </Typography>
                  </Box>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Food Sales'}
                  value1={formatNumber(sale && sale.totalLowTax) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'EBT Sales'}
                  value1={formatNumber(sale && sale.ebt) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Other Deductions'}
                  value1={formatNumber(sale && sale.otherDeductions) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <Grid item xs={12}>
                  <br></br>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Total Exemptions'}
                  value1={formatNumber(sale && sale.totalExempt) || ''}
                  value2={undefined}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' && (
                <Grid item xs={12}>
                  <br></br>
                </Grid>
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Net Taxable Sales'}
                  value1={
                    formatNumber(sale && sale.client && sale.totalHighTax) || ''
                  }
                  value2={formatNumber(
                    ((sale && sale.client && sale.totalHighTax) / 100) *
                    ((sale &&
                      sale.client &&
                      sale.client.salesTaxes &&
                      sale.client.salesTaxes.stateHighTax) ||
                      0)
                  )}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Food Sales'}
                  value1={
                    formatNumber(sale && sale.client && sale.totalLowTax) || ''
                  }
                  value2={formatNumber(
                    ((sale && sale.client && sale.totalLowTax) / 100) *
                    ((sale &&
                      sale.client &&
                      sale.client.salesTaxes &&
                      sale.client.salesTaxes.stateLowTax) ||
                      0)
                  )}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'City/County Taxes '}
                  value1={
                    formatNumber(
                      Number(sale && sale.client && sale.totalLowTax) +
                      Number(sale && sale.client && sale.totalHighTax)
                    ) || ''
                  }
                  value2={formatNumber(
                    ((Number(sale && sale.client && sale.totalLowTax) +
                      Number(sale && sale.client && sale.totalHighTax)) /
                      100) *
                    ((sale &&
                      sale.client &&
                      sale.client.salesTaxes &&
                      sale.client.salesTaxes.cityCountyTax) ||
                      0)
                  )}
                />
              )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'CBD Tax'}
                  value1={
                    formatNumber(sale && sale.client && sale.cbdDelta) || ''
                  }
                  value2={formatNumber(
                    ((sale && sale.client && sale.cbdDelta) / 100) *
                    ((sale &&
                      sale.client &&
                      sale.client.salesTaxes &&
                      sale.client.salesTaxes.cbdTax) ||
                      0)
                  )}
                />
              )}
            {/* Only show in Arkansas */}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'High Tax Sales'}
                value1={formatNumber(sale && sale.totalHighTax) || ''}
                value2={formatNumber(sale && sale.stateHighTax) || ''}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'Low Tax Sales'}
                value1={formatNumber(sale && sale.totalLowTax) || ''}
                value2={formatNumber(sale && sale.stateLowTax) || ''}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'Liquor Sales'}
                value1={formatNumber(sale && sale.wine) || ''}
                value2={formatNumber(sale && sale.liquorTax) || ''}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'Beer Sales'}
                value1={formatNumber(sale && sale.beer) || ''}
                value2={formatNumber(sale && sale.beerTax) || ''}
              />
            )}
            {sale &&
              sale.client &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'911 Fees '}
                  value1={formatNumber(sale && sale.fees911) || ''}
                  value2={formatNumber(sale && sale.total911) || ''}
                />
              )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'County Taxes '}
                value1={
                  formatNumber(
                    sale && +sale.totalHighTax + +sale.totalLowTax
                  ) || ''
                }
                value2={formatNumber(sale && sale.countyTax) || ''}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'City Taxes '}
                value1={
                  formatNumber(
                    sale && +sale.totalHighTax + +sale.totalLowTax
                  ) || ''
                }
                value2={formatNumber(sale && sale.cityTax) || ''}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <ViewField
                label={'Discount '}
                value1={formatNumber(sale && sale.discount) || ''}
                value2={null}
              />
            )}
            {sale && sale.client && sale.client.state === 'ARKANSAS' && (
              <Grid item xs={12}>
                <br></br>
              </Grid>
            )}
            {sale && sale.client && sale.client.state == 'ARKANSAS' && (
              <ViewField
                label={'Total Sales Tax'}
                value1={''}
                value2={
                  formatNumber(
                    (Number(sale?.totalSalesTax) || 0) - (Number(sale?.discount) || 0)
                  ) || ''
                }
              />
            )}
            {sale &&
              sale.client &&
              sale.client.state !== 'ARKANSAS' &&
              sale.client.state !== 'MISSOURI' &&
              sale.client.state !== 'MISSISSIPPI' && (
                <ViewField
                  label={'Total Sales Tax'}
                  value1={''}
                  value2={
                    formatNumber(sale && sale.client && sale.totalSalesTax) ||
                    ''
                  }
                />
              )}

            {/* Only Show in MISSOURI */}
            {sale?.client?.state === 'MISSOURI' &&
              (() => {
                const totalExempt =
                  (Number(sale?.saleTaxHoliday) || 0) +
                  (Number(sale?.otherExempt) || 0) +
                  (Number(sale?.exemptFood) || 0) +
                  (Number(sale?.newsPaper) || 0) +
                  (Number(sale?.carWash) || 0) +
                  (Number(sale?.ebt) || 0);

                const highGrossReceipts =
                  (Number(sale.totalHighTax) || 0) +
                  ((totalExempt || 0) - (Number(sale.ebt) || 0)) +
                  (Number(sale.gasolineAmount) || 0);

                const highAdjustment = -(
                  (Number(sale.gasolineAmount) || 0) +
                  ((totalExempt || 0) - (Number(sale.ebt) || 0))
                );
                const highTaxableSales = Number(sale.totalHighTax) || 0;
                const highTaxRate =
                  (Number(sale.client.salesTaxes.stateHighTax) || 0) +
                  (Number(sale.client.salesTaxes.cityTax) || 0) +
                  (Number(sale.client.salesTaxes.countyTax) || 0);
                const highAmountOfTax = (highTaxableSales * highTaxRate) / 100;

                const lowGrossReceipts =
                  (Number(sale.totalLowTax) || 0) + (Number(sale.ebt) || 0);
                const lowAdjustment = -(Number(sale.ebt) || 0);
                const lowTaxableSales = Number(sale.totalLowTax) || 0;
                const lowTaxRate =
                  (Number(sale.client.salesTaxes.stateLowTax) || 0) +
                  (Number(sale.client.salesTaxes.cityTax) || 0) +
                  (Number(sale.client.salesTaxes.countyTax) || 0);
                const lowAmountOfTax = (lowTaxableSales * lowTaxRate) / 100;

                const totalSalesTax = highAmountOfTax + lowAmountOfTax;
                const discount = -((totalSalesTax * 2) / 100);
                const netSalesTax = totalSalesTax + discount;

                return (
                  <>
                    {/* High Tax Sale Section */}
                    <Grid item xs={12} sm={12}>
                      <Box p={0} mt={1}>
                        <Typography
                          variant="h5"
                          color="black"
                          fontWeight="bold"
                        >
                          High Tax Sale
                        </Typography>
                      </Box>
                    </Grid>

                    <ViewField
                      label="Gross Receipts"
                      value1={formatNumber(highGrossReceipts)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Adjustment"
                      value1={`${formatNumber(highAdjustment)}`}
                      value2={undefined}
                      value1Color="red"
                    />
                    <ViewField
                      label="Taxable Sales"
                      value1={formatNumber(highTaxableSales)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Tax Rate"
                      value1={formatNumber(highTaxRate)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Amount Of Tax"
                      value1={formatNumber(highAmountOfTax)}
                      value2={undefined}
                    />

                    {/* Low Tax Sale Section */}
                    <Grid item xs={12} sm={12}>
                      <Box p={0} mt={1}>
                        <Typography
                          variant="h5"
                          color="black"
                          fontWeight="bold"
                        >
                          Low Tax Sale
                        </Typography>
                      </Box>
                    </Grid>

                    <ViewField
                      label="Gross Receipts"
                      value1={formatNumber(lowGrossReceipts)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Adjustment"
                      value1={formatNumber(lowAdjustment)}
                      value2={undefined}
                      value1Color='red'
                    />
                    <ViewField
                      label="Taxable Sales"
                      value1={formatNumber(lowTaxableSales)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Tax Rate"
                      value1={formatNumber(lowTaxRate)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Amount Of Tax"
                      value1={formatNumber(lowAmountOfTax)}
                      value2={undefined}
                    />

                    <Grid item xs={12}>
                      <br />
                    </Grid>

                    {/* Total Sales Tax */}
                    <ViewField
                      label="Total Sales Tax"
                      value1={formatNumber(totalSalesTax)}
                      value2={undefined}
                    />
                    <ViewField
                      label="Discount"
                      value1={formatNumber(discount)}
                      value2={undefined}
                      value1Color='red'
                    />
                    <ViewField
                      label="Net Sales Tax"
                      value1={formatNumber(netSalesTax)}
                      value2={undefined}
                    />
                  </>
                );
              })()}

            {sale?.client?.state === 'MISSISSIPPI' && (
              <>
                {(() => {
                  // Calculate "Other Non-Taxable Sales"
                  const otherNonTaxableSales =
                    (Number(sale?.saleTaxHoliday) || 0) +
                    (Number(sale?.otherExempt) || 0) +
                    (Number(sale?.exemptFood) || 0) +
                    (Number(sale?.newsPaper) || 0) +
                    (Number(sale?.carWash) || 0);

                  // Total deductions
                  const totalDeductions =
                    otherNonTaxableSales +
                    (Number(sale?.gasolineAmount) || 0) +
                    (Number(sale?.ebt) || 0);
                  const taxableGrossIncome =
                    (Number(sale?.totalSales) || 0) - totalDeductions;
                  // const calculatedTax = taxableGrossIncome * 0.07;
                  const totalSpecial = Number(sale?.hotFoodDeli) + Number(sale?.beer) || 0;
                  const specialTax = Number(sale?.specialTax) || 0;
                  const excessTaxCollected = Number(sale?.excessTaxCollected) || 0;
                  const credit = Number(sale?.credit) || 0;

                  const grossIncome =
                    (Number(sale?.gasolineAmount) || 0) +
                    (Number(otherNonTaxableSales) || 0) +
                    (Number(sale?.totalHighTax) || 0);
                  const completeDeductions =
                    -Number(otherNonTaxableSales) -
                    (Number(sale?.gasolineAmount) || 0);
                  const taxableGrossIncomeHigh =
                    Number(grossIncome) + Number(completeDeductions);
                  const taxRateHigh =
                    (Number(sale?.client?.salesTaxes?.stateHighTax) || 0) +
                    (Number(sale?.client?.salesTaxes?.cityTax) || 0) +
                    (Number(sale?.client?.salesTaxes?.countyTax) || 0);
                  const calculatedTaxHigh =
                    (Number(taxableGrossIncomeHigh) * Number(taxRateHigh)) /
                    100;

                  const retailSalesOfGroceryItems =
                    (Number(sale?.ebt) || 0) + (Number(sale?.totalLowTax) || 0);
                  const taxableGrossIncomeLow =
                    Number(retailSalesOfGroceryItems) - (Number(sale?.ebt) || 0);
                  const taxRateLow =
                    (Number(sale?.client?.salesTaxes?.stateLowTax) || 0) +
                    (Number(sale?.client?.salesTaxes?.cityTax) || 0) +
                    (Number(sale?.client?.salesTaxes?.countyTax) || 0);
                  const calculatedTaxLow =
                    (Number(taxableGrossIncomeLow) * Number(taxRateLow)) / 100;
                  const totalCalculatedTax =
                    Number(calculatedTaxHigh) + Number(calculatedTaxLow);
                  const totalSalesTax =
                    Number(totalCalculatedTax) + Number(specialTax);
                  const discount = Math.min(totalSalesTax * 0.02, 50);
                  const netSalesTax =
                    totalSalesTax - discount + excessTaxCollected - credit;

                  return (
                    <>
                      <ViewField
                        label="Gross Income"
                        value1={formatNumber(grossIncome) || ''}
                        value2={undefined}
                      />
                      <Grid item xs={12} sm={12}>
                        <Box p={0} mt={1}>
                          <Typography
                            variant="h5"
                            color="black"
                            fontWeight="bold"
                          >
                            Deductions
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Individual deduction fields */}
                      <ViewField
                        label="Sales of Motor Fuels"
                        value1={`- ${formatNumber(sale?.gasolineAmount)}`}
                        value2={undefined}
                        value1Color="red"
                      />

                      <ViewField
                        label="Other Non-Taxable Sales"
                        value1={`- ${formatNumber(otherNonTaxableSales)}`}
                        value2={undefined}
                        value1Color="red"
                      />
                      <ViewField
                        label="Complete Deductions"
                        value1={formatNumber(completeDeductions)}
                        value2={undefined}
                        value1Color="red"
                      />
                      <ViewField
                        label="Taxable Gross Income High"
                        value1={formatNumber(taxableGrossIncomeHigh)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Tax Rate High"
                        value1={formatNumber(taxRateHigh)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Calculated Tax High"
                        value1={formatNumber(calculatedTaxHigh)}
                        value2={undefined}
                      />
                      <Grid item xs={12}>
                        <br></br>
                      </Grid>
                      <ViewField
                        label="Retail Sales of Grocery Items"
                        value1={formatNumber(retailSalesOfGroceryItems)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Purchases made with SNAP EBT Card"
                        value1={`- ${formatNumber(sale?.ebt)}`}
                        value2={undefined}
                        value1Color="red"
                      />
                      <ViewField
                        label="Taxable Gross Income Low"
                        value1={formatNumber(taxableGrossIncomeLow)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Tax Rate Low"
                        value1={formatNumber(taxRateLow)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Calculated Tax Low"
                        value1={formatNumber(calculatedTaxLow)}
                        value2={undefined}
                      />

                      <Grid item xs={12}>
                        <br></br>
                      </Grid>
                      <ViewField
                        label="Total Calculated Tax"
                        value1={formatNumber(totalCalculatedTax)}
                        value2={undefined}
                      />
                                            <ViewField
                        label="Total Special "
                        value1={formatNumber(totalSpecial)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Special Tax"
                        value1={formatNumber(specialTax)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Total Sales Tax"
                        value1={formatNumber(totalSalesTax)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Discount"
                        value1={`- ${formatNumber(discount)}`}
                        value2={undefined}
                        value1Color="red"
                      />
                      <ViewField
                        label="Excess Tax Collected"
                        value1={formatNumber(excessTaxCollected)}
                        value2={undefined}
                      />
                      <ViewField
                        label="Credit"
                        value1={`- ${formatNumber(credit)}`}
                        value2={undefined}
                        value1Color="red"
                      />
                      <ViewField
                        label="Net Sales Tax"
                        value1={formatNumber(netSalesTax)}
                        value2={undefined}
                      />
                    </>
                  );
                })()}
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default ViewSales;
